import { MobileSearch } from './MobileSearch';

export default MobileSearch;
